const LS_TRIVLE_NAME = "trivle_player_name";

export { LS_TRIVLE_NAME };
